import { render, staticRenderFns } from "./AccountNotifications.vue?vue&type=template&id=3bee3a90&scoped=true&"
import script from "./AccountNotifications.vue?vue&type=script&lang=js&"
export * from "./AccountNotifications.vue?vue&type=script&lang=js&"
import style0 from "./AccountNotifications.vue?vue&type=style&index=0&id=3bee3a90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bee3a90",
  null
  
)

export default component.exports